<template>
  <div>
    <div
      class="painel-container"
      :style="
        'width: 100vw; min-height: 100vh;' +
        'background: ' +
        (configuracao.degrade
          ? 'radial-gradient(' + configuracao.background + ', #000000);'
          : configuracao.background)
      "
    >
      <div v-if="found && senhaAtual" class="painel-content">
        <!-- Header com a Senha -->
        <div class="senha-header">
          <div class="senha-text">
            <span class="senha-label">SENHA</span>
            <span class="senha-numero"
              >{{ senhaAtual.atendimento.prefixo
              }}{{ senhaAtual.atendimento.senha }}</span
            >
          </div>
        </div>

        <!-- Informação do Setor -->
        <div v-if="senhaAtual.setor" class="setor-info">
          <strong>Setor:</strong> {{ senhaAtual.setor.nome }}
        </div>

        <!-- Botão Senha Preferencial (se aplicável) -->
        <div v-if="senhaAtual.prioridade > 1" class="btn-preferencial">
          SENHA PREFERENCIAL - {{ senhaAtual.prioridade_f }}
        </div>

        <!-- Botão Editar Informações -->
        <div
          class="btn-editar"
          data-toggle="modal"
          data-target="#modalEditarPessoa"
          @click="abrirModalEdicao()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            style="margin-right: 8px"
          >
            <path
              d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
            ></path>
            <path
              d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
            ></path>
          </svg>
          EDITAR INFORMAÇÕES
        </div>

        <!-- Modal Editar Pessoa -->
        <div
          class="modal fade"
          id="modalEditarPessoa"
          tabindex="-1"
          role="dialog"
          aria-labelledby="modalEditarPessoaLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
              <div class="modal-header bg-primary">
                <h5
                  class="modal-title"
                  style="color: #eee"
                  id="modalEditarPessoaLabel"
                >
                  Cadastro
                </h5>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  @click="fecharCamera()"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-md-6 mt-1">
                    <label>CPF</label>
                    <div class="input-group">
                      <input
                        type="text"
                        class="form-control"
                        v-model="pessoa.cpf"
                        v-mask="'999.999.999-99'"
                      />
                      <div class="input-group-append">
                        <button
                          class="btn btn-primary"
                          type="button"
                          @click="getCpf()"
                        >
                          <i class="fas fa-search"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 mt-1">
                    <label>Data de Nascimento</label>
                    <input
                      type="date"
                      class="form-control"
                      v-model="pessoa.data_nascimento_form"
                    />
                  </div>
                  <div class="col-12 mt-1">
                    <label>Nome *</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="pessoa.nome"
                      maxlength="50"
                      @keypress="apenasLetras"
                      @paste="sanitizarColagem($event, 'nome')"
                    />
                  </div>
                  <div class="col-12 mt-1">
                    <label>Nome Social</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="pessoa.nomeSocialNovo"
                      maxlength="50"
                      @keypress="apenasLetras"
                      @paste="sanitizarColagem($event, 'nomeSocialNovo')"
                    />
                  </div>
                  <div class="col-12">
                    <label>Nome mãe</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="pessoa.nome_mae"
                      maxlength="50"
                      @keypress="apenasLetras"
                      @paste="sanitizarColagem($event, 'nome_mae')"
                    />
                  </div>
                  <div class="col-md-6">
                    <label>Telefone *</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="pessoa.telefone"
                      v-mask="'(99) 99999-9999'"
                    />
                  </div>
                  <div class="col-md-6">
                    <label>Gênero</label>
                    <select class="form-control" v-model="pessoa.sexo">
                      <option value="">Selecione</option>
                      <option value="M">Masculino</option>
                      <option value="F">Feminino</option>
                      <option value="O">Outros</option>
                    </select>
                  </div>
                  <div class="col-md-6">
                    <label>RG</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="pessoa.rg"
                      maxlength="20"
                      @keypress="apenasNumeros"
                    />
                  </div>
                  <div class="col-md-6">
                    <label>CNS</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="pessoa.cns"
                      v-mask="'###############'"
                      maxlength="15"
                      @keypress="apenasNumeros"
                      @input="pessoa.cns = (pessoa.cns || '').replace(/\D/g, '')"
                    />
                  </div>
                  <div class="col-12">
                    <label>Email</label>
                    <input
                      type="email"
                      class="form-control"
                      v-model="pessoa.email"
                    />
                  </div>
                  <div class="col-12">
                    <label>Alergias</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="pessoa.alergias"
                    />
                  </div>
                  <div class="col-12">
                    <label>CEP</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="pessoa.cep"
                      v-mask="'99999-999'"
                      @input="getEndereco()"
                    />
                  </div>
                  <div class="col-12">
                    <label>Logradouro</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="pessoa.logradouro"
                    />
                  </div>
                  <div class="col-md-6">
                    <label>Número</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="pessoa.numero"
                      maxlength="10"
                      @keypress="apenasAlfanumericos"
                    />
                  </div>
                  <div class="col-md-6">
                    <label>Complemento</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="pessoa.complemento"
                    />
                  </div>
                  <div class="col-12">
                    <label>Bairro</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="pessoa.bairro"
                    />
                  </div>
                  <div class="col-12">
                    <label>Cidade</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="pessoa.cidade"
                    />
                  </div>
                  <div class="col-12 mb-1">
                    <label>Estado</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="pessoa.estado"
                      maxlength="2"
                    />
                  </div>
                  <!-- Captura Facial (desativada temporariamente)
                  <div class="col-12 mb-2">
                    <label>Captura Facial</label>
                    <div
                      class="video-container"
                      style="
                        background: #000;
                        border-radius: 8px;
                        overflow: hidden;
                      "
                    >
                      <video
                        ref="video"
                        width="100%"
                        height="auto"
                        style="display: block; transform: scaleX(-1)"
                        playsinline
                      ></video>
                    </div>
                    <canvas
                      ref="canvas"
                      width="640"
                      height="480"
                      style="display: none"
                    ></canvas>
                  </div>
                  -->
                  <canvas
                    ref="canvas"
                    width="640"
                    height="480"
                    style="display: none"
                  ></canvas>
                  <div class="col-12 text-center my-2">
                    <button class="btn btn-success" @click="savePessoa()">
                      <i class="fas fa-save mr-1"></i>
                      Salvar
                    </button>
                    <!-- Botões de câmera (desativados temporariamente)
                    <button
                      v-if="!cameraAtiva"
                      class="btn btn-success mr-2"
                      @click="iniciarCamera"
                    >
                      <i class="fas fa-video mr-1"></i>
                      Ligar Câmera
                    </button>
                    <button
                      v-if="cameraAtiva"
                      class="btn btn-primary"
                      @click="tirarFoto"
                    >
                      <i class="fas fa-camera mr-1"></i>
                      Tirar Foto e Salvar
                    </button>
                    -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Se está AGUARDANDO (status 1) -->
        <div
          v-if="
            senhaAtual.status == 1 && senhaAtual.data_ultima_chamada == null
          "
        >
          <!-- Círculo de Progresso com Posição -->
          <div class="progress-circle-container">
            <svg
              class="progress-ring"
              width="240"
              height="240"
              viewBox="0 0 240 240"
            >
              <circle
                class="progress-ring-circle-bg"
                stroke="#e0e0e0"
                stroke-width="15"
                fill="transparent"
                r="110"
                cx="120"
                cy="120"
              />
              <circle
                class="progress-ring-circle"
                stroke="#17a2b8"
                stroke-width="15"
                fill="transparent"
                r="110"
                cx="120"
                cy="120"
                :style="
                  'stroke-dasharray: ' +
                  (posicao > 0
                    ? 691 * ((senhas.length - posicao + 1) / senhas.length)
                    : 691) +
                  ' 691'
                "
              />
            </svg>
            <div class="progress-content">
              <div class="posicao-label">Sua posição</div>
              <div class="posicao-numero">
                {{ posicao > 0 ? posicao : "-" }}
              </div>
            </div>
          </div>

          <!-- Card com Horário Previsto -->
          <div class="horario-card">
            <div class="horario-title">Horário previsto para o atendimento</div>
            <div class="horario-valor">{{ tempoEspera }}</div>
            <div class="horario-obs">
              A previsão pode variar durante sua espera.
            </div>
          </div>
        </div>

        <!-- Se foi CHAMADO (status 2) -->
        <div
          v-else-if="
            senhaAtual.status == 2 || senhaAtual.data_ultima_chamada != null
          "
        >
          <div class="chamada-card">
            <div class="chamada-titulo">CHEGOU A SUA VEZ!</div>
            <div class="chamada-destino">
              Dirija-se para<br />
              <strong>{{
                senhaAtual.setor ? senhaAtual.setor.nome : "Setor"
              }}</strong>
              <span v-if="senhaAtual.local">
                - {{ senhaAtual.local.nome }}</span
              >
            </div>
            <div class="chamada-vezes">
              Sua senha foi chamada {{ senhaAtual.vezes_chamado }} vez<span
                v-if="senhaAtual.vezes_chamado > 1"
                >es</span
              >.
            </div>
          </div>
        </div>

        <!-- Outro status -->
        <div v-else>
          <div class="horario-card">
            <div class="horario-title">
              Status: {{ senhaAtual.status_text }}
            </div>
          </div>
        </div>
      </div>

      <!-- Senha não encontrada -->
      <div v-else class="painel-content">
        <div
          class="card d-flex justify-content-center align-items-center w-100 px-3 py-5"
          :style="'color:' + configuracao.cor_primaria + ';'"
        >
          <h2 class="text-center">
            {{
              jaAtendido
                ? "Paciente já atendido"
                : "A senha procurada não existe ou já foi atendida"
            }}
          </h2>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BCardText, BLink } from "bootstrap-vue";
import { BCard, BCardBody, BAvatar } from "bootstrap-vue";

export default {
  data() {
    return {
      configuracao: {
        degrade: false,
        background: "#f8f9fa",
        cor_primaria: "#17a2b8",
      },
      found: false,
      jaAtendido: false,
      posicao: 0,
      senhaAtual: null,
      senhas: [],
      tempoEspera: "00:34:10",
      setorIdAtual: null, // Para rastrear mudanças de setor
      pessoa: {
        id: null,
        cpf: "",
        nome: "",
        nome_social: "",
        nomeSocialNovo: "",
        nome_mae: "",
        nome_pai: "",
        cns: "",
        sexo: "",
        data_nascimento: "",
        data_nascimento_form: "",
        telefone: "",
        cep: "",
        logradouro: "",
        bairro: "",
        cidade: "",
        estado: "",
        numero: "",
        complemento: "",
        rg: "",
        email: "",
        alergias: "",
        foto: "",
      },
      stream: null,
      fotoUrl: null,
      cameraAtiva: false,
      nomeOriginal: "",
      nomeSocialOriginal: "",
    };
  },
  components: {
    BCard,
    BCardText,
    BLink,
    BCard,
    BCardBody,
    BAvatar,
  },
  methods: {
    login() {
      const self = this;
      const api = this.$store.state.api + "login";
      self.$loading(true);

      axios
        .post(api, {
          login: "sistemas@it4d.com.br",
          password: "SystemPass",
        })
        .then((response) => {
          self.$store.commit("auth", response.data.access_token);
          setTimeout(() => {
            window.location.reload();
          }, 1000);
          self.$loading(false);
        })
        .catch((error) => {
          self.$loading(false);
          self.$message("Erro", error.response.data, "error");
        });
    },
    getSenha: function (id) {
      const self = this;
      const api =
        self.$store.state.api +
        "atendimento_setor?paginated=false&orderByDesc=data_entrada&with[]=atendimento&with[]=setor&with[]=local&atendimento_id=" +
        id;

      axios
        .get(api)
        .then((response) => {
          if (!response.data.data.length) {
            self.found = false;
            return;
          }

          const senha = response.data.data[0];

          const statusTerminal = [3, 4, 5];
          if (
            (senha.atendimento && senha.atendimento.ativo === 0) ||
            statusTerminal.includes(senha.status)
          ) {
            self.found = false;
            self.jaAtendido = true;
            return;
          }

          self.found = true;
          self.senhaAtual = senha;

          self.getFila(response.data.data[0].setor_id);
          self.getTempoMedio();
          self.dadosCompletos = true;

          // Conecta ao WebSocket para receber atualizações em tempo real
          self.conectarWebSocket(id);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    conectarWebSocket: function (atendimentoId) {
      const self = this;
      const setorId = self.senhaAtual.setor_id;

      // Guarda o setor atual
      self.setorIdAtual = setorId;

      setTimeout(function () {
        // Escuta o canal privado da senha específica (para este atendimento)
        Echo.private(`senha.${atendimentoId}`).listen(".SenhaEvent", (data) => {
          // O atendente pode encerrar/recriar o registro (ex: marcar como
          // ausente), gerando um novo atendimento_setor.id pro mesmo
          // atendimento — sem isso, o celular continuaria enviando
          // solicitações pro registro antigo, já fechado.
          if (data.id !== undefined) {
            self.senhaAtual.id = data.id;
          }
          if (data.status !== undefined) {
            self.senhaAtual.status = data.status;
          }
          if (data.status_text !== undefined) {
            self.senhaAtual.status_text = data.status_text;
          }
          if (data.vezes_chamado !== undefined) {
            self.senhaAtual.vezes_chamado = data.vezes_chamado;
          }
          if (data.data_ultima_chamada !== undefined) {
            self.senhaAtual.data_ultima_chamada = data.data_ultima_chamada;
          }
          if (data.local_obj) {
            self.senhaAtual.local = data.local_obj;
          }
          if (data.setor) {
            self.senhaAtual.setor = data.setor;
          }

          // Verifica se mudou de setor
          if (data.setor_id && data.setor_id !== self.setorIdAtual) {
            // Desconecta do canal do setor antigo
            if (self.setorIdAtual) {
              Echo.leave(`fila-setor.${self.setorIdAtual}`);
            }

            // Atualiza o setor atual
            self.setorIdAtual = data.setor_id;
            self.senhaAtual.setor_id = data.setor_id;

            // Conecta no canal do novo setor
            self.conectarCanalSetor(data.setor_id);

            // Atualiza a fila do novo setor
            self.getFila(data.setor_id);
          }

          // Recalcula o tempo estimado após qualquer atualização
          self.calcularTempoEstimado();
        });

        // Escuta o canal do setor (para atualizar a fila quando qualquer senha mudar)
        if (setorId) {
          self.conectarCanalSetor(setorId);
        }
      }, 3000);
    },
    conectarCanalSetor: function (setorId) {
      const self = this;

      Echo.private(`fila-setor.${setorId}`).listen(
        ".FilaSetorEvent",
        (data) => {
          // Atualiza a fila e recalcula o tempo estimado
          self.getFila(setorId);
        }
      );
    },
    atualizarSenhaAtual: function (id) {
      const self = this;
      const api =
        self.$store.state.api +
        "atendimento_setor?paginated=false&orderByDesc=data_entrada&with[]=atendimento&with[]=setor&with[]=local&atendimento_id=" +
        id;

      axios
        .get(api)
        .then((response) => {
          if (response.data.data.length) {
            // Atualiza apenas os dados que podem mudar
            const novaSenha = response.data.data[0];
            self.senhaAtual.status = novaSenha.status;
            self.senhaAtual.vezes_chamado = novaSenha.vezes_chamado;
            self.senhaAtual.data_ultima_chamada = novaSenha.data_ultima_chamada;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getFila: function (id) {
      const self = this;
      const api = self.$store.state.api + "fila-pessoa/" + id;

      axios
        .get(api)
        .then((response) => {
          self.senhas = response.data;

          self.senhas.forEach((senha, index) => {
            if (senha.atendimento_id === self.senhaAtual.atendimento_id) {
              self.posicao = index + 1;
            }
          });

          // Atualiza o tempo estimado após calcular a posição
          self.calcularTempoEstimado();

          self.dadosCompletos = true;

          self.senhas.push();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getTempoMedio: function () {
      // Este método agora só é chamado na inicialização
      // O cálculo real é feito em calcularTempoEstimado()
      const self = this;
      self.calcularTempoEstimado();
    },
    calcularTempoEstimado: function () {
      const self = this;

      // Usa o tempo médio que já vem no atributo append do model
      if (self.senhaAtual && self.senhaAtual.tempo_medio_atendimento) {
        const tempoMedioSegundos = self.senhaAtual.tempo_medio_atendimento;

        // Multiplica pelo número de pessoas na frente (posição - 1)
        // Se você está na posição 43, tem 42 pessoas na sua frente
        const pessoasNaFrente = self.posicao > 1 ? self.posicao - 1 : 0;
        const tempoEstimadoSegundos = tempoMedioSegundos * pessoasNaFrente;

        // Calcula o horário previsto
        const agora = new Date();
        const horarioPrevisto = new Date(
          agora.getTime() + tempoEstimadoSegundos * 1000
        );

        // Formata o horário
        const horas = String(horarioPrevisto.getHours()).padStart(2, "0");
        const minutos = String(horarioPrevisto.getMinutes()).padStart(2, "0");

        self.tempoEspera = `${horas}:${minutos}`;
      } else {
        self.tempoEspera = "--:--";
      }
    },
    getConfiguracao: function () {
      const self = this;
      const api = self.$store.state.api + "configuracoes/";

      axios
        .get(api)
        .then((response) => {
          self.configuracao = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    apenasLetras(event) {
      const char = String.fromCharCode(event.keyCode || event.which);
      if (!/^[a-zA-ZÀ-ÿ\s\-']$/.test(char)) {
        event.preventDefault();
      }
    },
    sanitizarColagem(event, campo) {
      event.preventDefault();
      const texto = event.clipboardData
        ? event.clipboardData.getData("text")
        : "";
      const sanitizado = texto
        .replace(/[^a-zA-ZÀ-ÿ\s\-']/g, "")
        .substring(0, 100);
      this.pessoa[campo] = sanitizado;
    },
    apenasNumeros(event) {
      const char = String.fromCharCode(event.keyCode || event.which);
      if (!/^\d$/.test(char)) {
        event.preventDefault();
      }
    },
    apenasAlfanumericos(event) {
      const char = String.fromCharCode(event.keyCode || event.which);
      if (!/^[a-zA-Z0-9]$/.test(char)) {
        event.preventDefault();
      }
    },
    abrirModalEdicao: function () {
      const self = this;

      // Garante que a câmera está desligada ao abrir o modal
      self.fecharCamera();
      self.cameraAtiva = false;

      // Se tem pessoa_id no atendimento, busca os dados
      if (
        self.senhaAtual &&
        self.senhaAtual.atendimento &&
        self.senhaAtual.atendimento.pessoa_id
      ) {
        self.getPessoa(self.senhaAtual.atendimento.pessoa_id);
      } else {
        // Limpa o objeto pessoa para criar um novo
        self.pessoa = {
          id: null,
          cpf: "",
          nome: "",
          nome_social: "",
          nome_mae: "",
          nome_pai: "",
          cns: "",
          sexo: "",
          data_nascimento: "",
          data_nascimento_form: "",
          telefone: "",
          cep: "",
          logradouro: "",
          bairro: "",
          cidade: "",
          estado: "",
          numero: "",
          complemento: "",
          rg: "",
          email: "",
          alergias: "",
          foto: "",
        };
      }
    },
    getPessoa: function (id) {
      const self = this;
      const api = self.$store.state.api + "pessoas/" + id;

      axios
        .get(api)
        .then((response) => {
          self.pessoa = response.data.data[0];
          self.nomeOriginal = self.pessoa.nome || "";
          self.pessoa.nomeSocialNovo = self.pessoa.nome_social || "";
          self.nomeSocialOriginal = self.pessoa.nomeSocialNovo;
          // Formata a data de nascimento se existir
          if (self.pessoa.data_nascimento) {
            self.pessoa.data_nascimento_form =
              self.pessoa.data_nascimento.split("T")[0];
          }
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getCpf: function () {
      const self = this;

      if (self.pessoa.cpf && self.pessoa.cpf.split("")[13] !== "_") {
        const api = self.$store.state.api + "get-cpf";

        axios
          .post(api, {
            documento: self.pessoa.cpf.replace("-", "").replaceAll(".", ""),
            tipoDocumento: "CPF",
          })
          .then((response) => {
            if (response.data.erro) {
              return self.$message("Atenção!", "CPF não encontrado", "warning");
            }

            const dados =
              response.data.pessoa?.content ||
              response.data.content ||
              response.data;

            if (!dados || !dados.nome) {
              return self.$message("Atenção!", "CPF não encontrado", "warning");
            }

            self.pessoa.nome = dados.nome;
            self.pessoa.nome_social = dados.nomeSocial || dados.nome;
            self.nomeOriginal = self.pessoa.nome;
            self.pessoa.nomeSocialNovo = dados.nomeSocial || "";
            self.nomeSocialOriginal = self.pessoa.nomeSocialNovo;
            self.pessoa.nome_mae = dados.nomeMae;
            self.pessoa.nome_pai = dados.nomePai;
            self.pessoa.cns = dados.codigoCNS;
            self.pessoa.cpf = dados.cpf;
            self.pessoa.sexo = dados.sexo;
            self.pessoa.data_nascimento = dados.dataNascimento;
            self.pessoa.data_nascimento_form =
              dados.dataNascimento?.split("T")[0] || "";
            self.pessoa.telefone =
              dados.telefoneCelular || dados.telefoneResidencial || "";
            self.pessoa.cep = dados.cep;
            self.pessoa.logradouro = dados.logradouro;
            self.pessoa.bairro = dados.bairro;
            self.pessoa.cidade = dados.municipio;
            self.pessoa.estado = dados.estado;
            self.pessoa.numero = dados.numero;
            self.pessoa.complemento = dados.complemento;

            self.$message("Pessoa encontrada", dados.nome, "success");
          })
          .catch(() => {
            self.$message("Atenção!", "CPF não encontrado", "warning");
          });
      }
    },
    getEndereco: function () {
      const self = this;

      if (self.pessoa.cep && self.pessoa.cep.length === 9) {
        const cep = self.pessoa.cep.replace("-", "");
        const api = `https://viacep.com.br/ws/${cep}/json/`;

        axios
          .get(api)
          .then((response) => {
            if (!response.data.erro) {
              self.pessoa.logradouro = response.data.logradouro;
              self.pessoa.bairro = response.data.bairro;
              self.pessoa.cidade = response.data.localidade;
              self.pessoa.estado = response.data.uf;
            }
          })
          .catch((error) => {
            console.log("Erro ao buscar CEP:", error);
          });
      }
    },
    async iniciarCamera() {
      const self = this;
      try {
        self.stream = await navigator.mediaDevices.getUserMedia({
          video: {
            width: { ideal: 1280 },
            height: { ideal: 720 },
            facingMode: "user", // Força câmera frontal
          },
        });

        self.$refs.video.srcObject = self.stream;

        // Aguarda o vídeo estar pronto e inicia a reprodução
        await self.$refs.video.play();
        self.cameraAtiva = true;

        self.$message(
          "Câmera ativada",
          "Câmera iniciada com sucesso",
          "success"
        );
      } catch (error) {
        console.error("Erro ao acessar a câmera:", error);
        self.cameraAtiva = false;
        self.$message(
          "Erro na câmera",
          "Não foi possível acessar a câmera. Verifique as permissões.",
          "error"
        );
      }
    },
    tirarFoto() {
      const self = this;

      if (!self.cameraAtiva) {
        self.$message(
          "Atenção",
          "Por favor, ligue a câmera primeiro",
          "warning"
        );
        return;
      }

      const video = self.$refs.video;
      const canvas = self.$refs.canvas;

      if (!video || !canvas) {
        self.$message("Erro", "Elementos de vídeo não encontrados", "error");
        return;
      }

      // Ajusta o canvas para o tamanho real do vídeo
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;

      const context = canvas.getContext("2d");

      // Espelha horizontalmente antes de desenhar
      context.translate(canvas.width, 0);
      context.scale(-1, 1);

      // Desenha a imagem do vídeo no canvas (espelhada)
      context.drawImage(video, 0, 0, canvas.width, canvas.height);

      // Reseta a transformação
      context.setTransform(1, 0, 0, 1, 0, 0);

      self.fotoUrl = canvas.toDataURL("image/png");

      const api = self.$store.state.api + "cadastramento-facial";

      self.pessoa.foto = self.fotoUrl;

      self.$loading(true);

      axios
        .post(api, self.pessoa)
        .then(() => {
          self.savePessoa();
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });

      self.fecharCamera();
    },
    fecharCamera() {
      const self = this;
      if (self.stream) {
        self.stream.getTracks().forEach((track) => track.stop());
        self.stream = null;
        if (self.$refs.video) {
          self.$refs.video.srcObject = null;
        }
        self.cameraAtiva = false;
      }
    },
    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      fd.append("cpf", self.pessoa.cpf ? self.pessoa.cpf : "");
      fd.append("cns", self.pessoa.cns ? self.pessoa.cns : "");
      // nome/nome_social: pessoa existente → envia original de cada campo; pessoa nova → "Em aprovação" (placeholder até operador aprovar)
      const nomeParaSalvar = self.nomeOriginal || "Em aprovação";
      const nomeSocialParaSalvar = self.nomeSocialOriginal || nomeParaSalvar;
      fd.append("nome", nomeParaSalvar);
      fd.append("nome_social", nomeSocialParaSalvar);
      fd.append("nome_mae", self.pessoa.nome_mae ? self.pessoa.nome_mae : "");
      fd.append("nome_pai", self.pessoa.nome_pai ? self.pessoa.nome_pai : "");
      fd.append("cep", self.pessoa.cep ? self.pessoa.cep : "");
      fd.append(
        "logradouro",
        self.pessoa.logradouro ? self.pessoa.logradouro : ""
      );
      fd.append("numero", self.pessoa.numero ? self.pessoa.numero : "");
      fd.append(
        "complemento",
        self.pessoa.complemento ? self.pessoa.complemento : ""
      );
      fd.append("bairro", self.pessoa.bairro ? self.pessoa.bairro : "");
      fd.append("cidade", self.pessoa.cidade ? self.pessoa.cidade : "");
      fd.append("estado", self.pessoa.estado ? self.pessoa.estado : "");
      fd.append("telefone", self.pessoa.telefone ? self.pessoa.telefone : "");
      fd.append("rg", self.pessoa.rg ? self.pessoa.rg : "");
      fd.append("email", self.pessoa.email ? self.pessoa.email : "");
      fd.append("alergias", self.pessoa.alergias ? self.pessoa.alergias : "");
      fd.append(
        "data_nascimento",
        self.pessoa.data_nascimento_form ? self.pessoa.data_nascimento_form : ""
      );
      fd.append("sexo", self.pessoa.sexo ? self.pessoa.sexo : "");

      // Se tem foto capturada da webcam (base64), envia ela
      if (self.pessoa.foto && self.pessoa.foto.startsWith("data:image")) {
        fd.append("foto", self.pessoa.foto);
      } else {
        fd.append("foto", "");
      }

      if (self.pessoa.id) {
        fd.append("id", self.pessoa.id);
        fd.append("_method", "PUT");
      }

      return fd;
    },
    savePessoa: function () {
      const self = this;

      if (!self.pessoa.nome || !self.pessoa.nome.trim()) {
        return self.$message(
          "Atenção",
          "O campo Nome é obrigatório",
          "warning"
        );
      }
      if (
        !self.pessoa.telefone ||
        self.pessoa.telefone.replace(/\D/g, "").length < 10
      ) {
        return self.$message(
          "Atenção",
          "O campo Telefone é obrigatório",
          "warning"
        );
      }

      var api = self.$store.state.api + "pessoas/";

      self.$loading(true);

      if (self.pessoa.id) {
        api += self.pessoa.id;
      }

      let fd = self.makeFormData();

      axios
        .post(api, fd)
        .then((response) => {
          const pessoaId =
            response.data && response.data.id ? response.data.id : null;

          // Nome digitado sempre vai para triagem do operador
          const novoNome = (self.pessoa.nome || "").trim();

          const isPessoaNova = !self.nomeOriginal; // sem nomeOriginal = pessoa nova/sem cadastro

          if (pessoaId && !isPessoaNova) {
            // Pessoa já existia: vincula normalmente
            if (!self.senhaAtual.atendimento.pessoa_id) {
              self.addPessoa(pessoaId);
            }
            self.getPessoa(pessoaId);
          }
          // Pessoa nova: NÃO vincula ainda — só vincula após aprovação do operador

          const nomeAlterado = novoNome && novoNome !== self.nomeOriginal;

          const novoNomeSocial = (self.pessoa.nomeSocialNovo || "").trim();
          // Pra pessoa nova (isPessoaNova) ainda não existe nomeSocialOriginal
          // pra comparar — envia sempre que preenchido, junto com o nome, pra
          // não precisar de um segundo envio depois que a pessoa for criada.
          const nomeSocialAlterado = isPessoaNova
            ? !!novoNomeSocial
            : novoNomeSocial && novoNomeSocial !== self.nomeSocialOriginal;

          if (
            (nomeAlterado || nomeSocialAlterado) &&
            self.senhaAtual &&
            self.senhaAtual.id
          ) {
            const apiNome =
              self.$store.state.api +
              "atendimento_setor/" +
              self.senhaAtual.id +
              "/solicitar-edicao-nome";
            const payload = {};
            if (nomeAlterado) {
              payload.nome = novoNome;
            }
            if (nomeSocialAlterado) {
              payload.nome_social = novoNomeSocial;
            }
            if (isPessoaNova && pessoaId) {
              payload.pessoa_id_pendente = pessoaId;
            }
            axios
              .post(apiNome, payload)
              .then(() => {
                self.$message(
                  "Atenção",
                  "Alteração de nome enviada para aprovação de um operador.",
                  "warning"
                );
              })
              .catch((err) => {
                console.error("Erro ao solicitar edição de nome:", err);
              });
          } else {
            self.$message(
              "Sucesso",
              "Informações guardadas com sucesso",
              "success"
            );
          }

          self.$loading(false);
          $("#modalEditarPessoa").modal("hide");
        })
        .catch((error) => {
          console.log("Error:", error);
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
    addPessoa: function (id) {
      const self = this;
      const api =
        self.$store.state.api + "addPessoa/" + self.senhaAtual.atendimento.id;

      axios
        .post(api, { pessoa_id: id })
        .then(() => {
          self.senhaAtual.atendimento.pessoa_id = id;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted() {
    const self = this;
    let id = self.$route.params.id;

    var token = localStorage.getItem("token");

    if (!token) {
      self.login();
    } else {
      self.getConfiguracao();

      if (id) {
        self.getSenha(id);
      }
    }
  },
  beforeDestroy() {
    // Desconecta do WebSocket ao sair da página
    const id = this.$route.params.id;
    if (id) {
      Echo.leave(`senha.${id}`);
    }
    if (this.senhaAtual && this.senhaAtual.setor_id) {
      Echo.leave(`fila-setor.${this.senhaAtual.setor_id}`);
    }
  },
  created() {},
};
</script>

<style scoped>
.painel-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
}

.painel-content {
  width: 100%;
  max-width: 500px;
  padding: 20px;
}

/* Header com a Senha */
.senha-header {
  background: #17a2b8;
  border-radius: 50px;
  padding: 15px 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.flag-icon {
  background: white;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #17a2b8;
}

.senha-text {
  display: flex;
  align-items: center;
  gap: 10px;
  color: white;
  font-weight: bold;
  font-size: 1.5rem;
}

.senha-label {
  font-size: 1.2rem;
}

.senha-numero {
  font-size: 2rem;
  letter-spacing: 2px;
}

.close-icon {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  cursor: pointer;
}

/* Informação do Setor */
.setor-info {
  background: rgba(255, 255, 255, 0.15);
  color: white;
  border-radius: 15px;
  padding: 12px 20px;
  text-align: center;
  font-size: 1rem;
  margin-bottom: 15px;
  backdrop-filter: blur(10px);
}

/* Botão Preferencial */
.btn-preferencial {
  background: #dc3545;
  color: white;
  border-radius: 50px;
  padding: 15px 25px;
  text-align: center;
  font-weight: bold;
  font-size: 1rem;
  margin-bottom: 15px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  text-transform: uppercase;
}

/* Botão Editar */
.btn-editar {
  background: #17a2b8;
  color: white;
  border-radius: 50px;
  padding: 15px 25px;
  text-align: center;
  font-weight: bold;
  font-size: 0.95rem;
  margin-bottom: 30px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  text-transform: uppercase;
}

/* Círculo de Progresso */
.progress-circle-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px 0;
}

.progress-ring {
  transform: rotate(-90deg);
  max-width: 100%;
  height: auto;
}

.progress-ring-circle-bg {
  opacity: 0.3;
}

.progress-ring-circle {
  transition: stroke-dasharray 0.5s ease;
  stroke-linecap: round;
}

.progress-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.posicao-label {
  font-size: 1rem;
  color: #ffffff;
  margin-bottom: 5px;
  font-weight: 500;
}

.posicao-numero {
  font-size: 4.5rem;
  font-weight: bold;
  color: #ffffff;
  line-height: 1;
}

/* Card de Chamada */
.chamada-card {
  background: #dc3545;
  border-radius: 25px;
  padding: 30px;
  text-align: center;
  color: white;
  box-shadow: 0 4px 20px rgba(220, 53, 69, 0.3);
  margin: 30px 0;
}

.chamada-titulo {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 20px;
  text-transform: uppercase;
}

.chamada-destino {
  font-size: 1.3rem;
  margin-bottom: 20px;
  line-height: 1.6;
}

.chamada-destino strong {
  font-size: 1.8rem;
  display: block;
  margin-top: 10px;
}

.chamada-vezes {
  font-size: 1rem;
  opacity: 0.9;
  margin-top: 15px;
}

/* Card Horário */
.horario-card {
  background: #2c3e50;
  border-radius: 25px;
  padding: 25px;
  text-align: center;
  color: white;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.horario-title {
  font-size: 1rem;
  font-weight: bold;
  margin-bottom: 10px;
}

.horario-valor {
  font-size: 2rem;
  font-weight: bold;
  color: #17a2b8;
  margin-bottom: 10px;
}

.horario-obs {
  font-size: 0.9rem;
  font-style: italic;
  opacity: 0.8;
}

/* Responsividade */
@media (max-width: 600px) {
  .senha-numero {
    font-size: 1.5rem;
  }

  .posicao-numero {
    font-size: 4rem;
  }

  .progress-ring {
    width: 240px;
    height: 240px;
  }
}
</style>
